import api from "@/services/api";

export default {
  fetchKpiList() {
    return api.get(`kpilist/`).then((response) => response.data);
  },
};
